<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">NF-es de entrada</h1>
            <p class="welcome-message">
              Todas as notas de entrada em um só lugar - capturadas da SEFAZ, importadas por XML ou lançadas
              manualmente
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-6 header-actions">
        <button mat-stroked-button type="button" class="btn-secondary" [matMenuTriggerFor]="acoesMenu">
          @if (selection.hasValue()) {
            <span>Ações ({{ selection.selected.length }})</span>
          } @else {
            <span>Ações</span>
          }
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #acoesMenu="matMenu">
          @if (selection.hasValue()) {
            <button mat-menu-item (click)="excluirNotas()">
              <mat-icon class="material-symbols-outlined">delete</mat-icon>
              <span>Excluir {{ selection.selected.length }} notas selecionadas</span>
            </button>
            <button mat-menu-item (click)="alterarTags()">
              <mat-icon class="material-symbols-outlined">label</mat-icon>
              <span>Alterar tags</span>
            </button>
            <button mat-menu-item (click)="exportar(selection.selected)">
              <mat-icon class="material-symbols-outlined">file_download</mat-icon>
              <span>Exportar selecionadas</span>
            </button>
            <button mat-menu-item (click)="selection.clear()">
              <mat-icon class="material-symbols-outlined">deselect</mat-icon>
              <span>Limpar seleção</span>
            </button>
          } @else {
            <button mat-menu-item (click)="incluirNotaFiscal()">
              <mat-icon class="material-symbols-outlined">note_add</mat-icon>
              <span>Incluir nota fiscal</span>
            </button>
            <button mat-menu-item (click)="exportar()">
              <mat-icon class="material-symbols-outlined">file_download</mat-icon>
              <span>Exportar</span>
            </button>
          }
        </mat-menu>

        <button mat-flat-button type="button" class="btn-primary" (click)="importarXml()">
          <mat-icon class="material-symbols-outlined">upload_file</mat-icon>
          Importar XML
        </button>
      </div>
    </div>

    <form [formGroup]="model" (ngSubmit)="aplicarFiltros()">
      <div class="row search-area">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>Pesquisar</mat-label>
            <input
              matInput
              type="text"
              formControlName="pesquisa"
              placeholder="Pesquisar nº da NF, fornecedor, CNPJ ou chave" />
            <button
              mat-icon-button
              matSuffix
              type="submit"
              class="icon-mat-symbols-btn"
              aria-label="Pesquisar">
              <mat-icon class="material-symbols-outlined">search</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 filter-container">
          <button
            #periodoMenuTrigger="matMenuTrigger"
            mat-stroked-button
            type="button"
            class="btn-periodo"
            [matMenuTriggerFor]="periodoMenu"
            [class.btn-periodo--ativo]="periodoSelecionado !== periodoEnum.DoMes">
            {{ periodoLabel }}
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #periodoMenu="matMenu" class="periodo-custom-menu">
            <div class="periodo-menu-content">
              @for (opcao of opcoesPeriodo; track opcao.periodo) {
                <button
                  type="button"
                  class="periodo-menu-item"
                  [class.periodo-item-selecionado]="periodoSelecionado === opcao.periodo"
                  (click)="selecionarPeriodo(opcao.periodo, $event)">
                  <span>{{ opcao.rotulo }}</span>
                  @if (periodoSelecionado === opcao.periodo) {
                    <mat-icon>check</mat-icon>
                  }
                </button>
              }

              @if (periodoSelecionado === periodoEnum.DoIntervalo) {
                <div class="periodo-intervalo-fields" (click)="$event.stopPropagation()">
                  <mat-form-field appearance="outline">
                    <mat-label>De</mat-label>
                    <input
                      matInput
                      [matDatepicker]="pickerDe"
                      placeholder="DD/MM/AAAA"
                      (input)="onDateInput($event, 'dataDe')"
                      formControlName="dataDe" />
                    <mat-datepicker-toggle matSuffix [for]="pickerDe"></mat-datepicker-toggle>
                    <mat-datepicker #pickerDe></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Até</mat-label>
                    <input
                      matInput
                      [matDatepicker]="pickerAte"
                      placeholder="DD/MM/AAAA"
                      (input)="onDateInput($event, 'dataAte')"
                      formControlName="dataAte" />
                    <mat-datepicker-toggle matSuffix [for]="pickerAte"></mat-datepicker-toggle>
                    <mat-datepicker #pickerAte></mat-datepicker>
                  </mat-form-field>
                  <div class="periodo-intervalo-actions">
                    <button
                      type="button"
                      mat-button
                      class="btn-secondary"
                      (click)="cancelarIntervalo(periodoMenuTrigger)">
                      Cancelar
                    </button>
                    <button
                      type="button"
                      mat-flat-button
                      class="btn-primary"
                      (click)="aplicarIntervalo(periodoMenuTrigger)">
                      Aplicar
                    </button>
                  </div>
                </div>
              }
            </div>
          </mat-menu>

          <button
            mat-stroked-button
            type="button"
            class="btn-filter"
            [matMenuTriggerFor]="filtroMenu"
            [matBadge]="qtdFiltrosAvancados"
            [matBadgeHidden]="qtdFiltrosAvancados === 0">
            <mat-icon>filter_list</mat-icon>
            Filtrar
          </button>
          <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
            <div class="filter-menu-content" [formGroup]="model">
              <div (click)="$event.stopPropagation()">
                <h6>Filtros</h6>
                <div class="filter-menu__form">
                  <app-select-pesquisavel
                    label="Status"
                    [control]="$any(model.get('status'))"
                    [idField]="'id'"
                    [nameField]="'nome'"
                    [offlineList]="listaStatus"
                    [multiple]="true"
                    [isOptional]="true"
                    hint="Selecione os status">
                  </app-select-pesquisavel>

                  <app-select-pesquisavel
                    label="Origem"
                    [control]="$any(model.get('origem'))"
                    [idField]="'id'"
                    [nameField]="'nome'"
                    [offlineList]="listaOrigem"
                    [multiple]="true"
                    [isOptional]="true"
                    hint="Selecione as origens">
                  </app-select-pesquisavel>

                  <app-select-pesquisavel
                    label="Fornecedor"
                    [control]="$any(model.get('fornecedor'))"
                    [idField]="'id'"
                    [nameField]="'descricao'"
                    [apiUrl]="urlFornecedor"
                    [multiple]="true"
                    [isOptional]="true"
                    hint="Selecione um fornecedor">
                  </app-select-pesquisavel>

                  <app-select-pesquisavel
                    label="Tags"
                    [control]="$any(model.get('tags'))"
                    [idField]="'idTagNFeEntrada'"
                    [nameField]="'descricao'"
                    [offlineList]="listaTags"
                    [multiple]="true"
                    [isOptional]="true"
                    hint="Selecione as tags">
                  </app-select-pesquisavel>

                  <app-select-pesquisavel
                    label="Destinatário"
                    [control]="$any(model.get('destinatario'))"
                    [idField]="'idEmpresa'"
                    [nameField]="'nomeEmpresa'"
                    [offlineList]="listaEmpresas"
                    [multiple]="true"
                    [isOptional]="true"
                    [hint]="
                      isSingleCompanyView
                        ? 'Filtro travado: o grupo tem uma única empresa'
                        : 'Empresa para a qual a NF-e foi emitida'
                    ">
                  </app-select-pesquisavel>
                </div>
              </div>

              <div class="filter-menu__actions">
                <button mat-button type="button" class="btn-secondary" matMenuClose>Cancelar</button>
                <button
                  mat-flat-button
                  type="button"
                  class="btn-primary"
                  (click)="aplicarFiltros()"
                  matMenuClose>
                  Aplicar
                </button>
              </div>
            </div>
          </mat-menu>

          <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
            <mat-icon>cleaning_services</mat-icon>
            Limpar Filtros
          </button>
        </div>
      </div>
    </form>

    <div class="cards-filtro">
      <div class="cards-filtro-grade">
        @for (opcao of opcoesResumo; track opcao.resumo) {
          <button
            type="button"
            class="card-filtro"
            [ngClass]="opcao.cor"
            [class.active]="resumoFiltro === opcao.resumo"
            (click)="selecionarResumo(opcao.resumo)">
            <span class="card-filtro-rotulo">
              <span class="dot"></span>
              {{ opcao.rotulo }}
            </span>
            <span class="card-filtro-valor">{{ valorResumo(opcao.resumo) }}</span>
            <span class="card-filtro-sub">{{ opcao.subtexto }}</span>
          </button>
        }
      </div>

      <div class="cards-filtro-select">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Filtrar por</mat-label>
          <mat-select [value]="resumoFiltro" (selectionChange)="selecionarResumo($event.value)">
            <mat-select-trigger>
              <span class="dot dot-filtro" [ngClass]="opcaoResumoAtual.cor"></span>
              {{ opcaoResumoAtual.rotulo }} ({{ valorResumo(resumoFiltro) }})
            </mat-select-trigger>
            @for (opcao of opcoesResumo; track opcao.resumo) {
              <mat-option [value]="opcao.resumo">
                <span class="dot dot-filtro" [ngClass]="opcao.cor"></span>
                {{ opcao.rotulo }} ({{ valorResumo(opcao.resumo) }})
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    @if (dataSource.data.length > 0) {
      <div class="table-container desktop-view">
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef class="w-checkbox">
              <mat-checkbox
                (change)="toggleAllRows()"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"></mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row" class="w-checkbox">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="selection.toggle(row)"
                [checked]="selection.isSelected(row)"></mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="nota">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>NF-e / Série</th>
            <td mat-cell *matCellDef="let row">{{ nota(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="emissao">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Emissão</th>
            <td mat-cell *matCellDef="let row">{{ row.dataEmissao | date: 'dd/MM/yyyy' }}</td>
          </ng-container>

          <ng-container matColumnDef="lancamento">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Lançamento</th>
            <td mat-cell *matCellDef="let row">
              @if (isPreXml(row)) {
                <span matTooltip="Disponível após o XML completo">—</span>
              } @else {
                {{ row.dataEntradaSaida ? (row.dataEntradaSaida | date: 'dd/MM/yyyy') : '—' }}
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="destinatario">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Destinatário</th>
            <td mat-cell *matCellDef="let row" [matTooltip]="destinatario(row)">
              <span class="truncate-cell">{{ destinatario(row) }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="fornecedor">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Fornecedor</th>
            <td mat-cell *matCellDef="let row" [matTooltip]="fornecedor(row)">
              <span class="truncate-cell">{{ fornecedor(row) }}</span>
              @if (row.cnpjCpfEmitente) {
                <small class="fornecedor-documento">{{ row.cnpjCpfEmitente | cpfCnpj }}</small>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="valor">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Valor (R$)</th>
            <td mat-cell *matCellDef="let row" class="text-end nota-valor-cell">
              {{ row.valorTotal || 0 | abnt: 'preco' : 2 }}
            </td>
          </ng-container>

          <ng-container matColumnDef="origem">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Origem</th>
            <td mat-cell *matCellDef="let row">
              <span class="status-badge badge-cinza">
                <mat-icon class="material-symbols-outlined">{{ iconeOrigem(row) }}</mat-icon>
                {{ origem(row) }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="manifestacao">
            <th mat-header-cell *matHeaderCellDef>Manifestação</th>
            <td mat-cell *matCellDef="let row">
              @if (temManifestacao(row)) {
                <span class="status-badge" [ngClass]="classeBadgeManifestacao(row)">{{
                  manifestacao(row)
                }}</span>
              } @else {
                —
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="integracoes">
            <th mat-header-cell *matHeaderCellDef class="text-center">Integrações</th>
            <td mat-cell *matCellDef="let row" class="text-center">
              @if (integracoes(row).length) {
                <span class="indicador-grid">
                  @for (integracao of integracoes(row); track integracao.sigla) {
                    <span
                      class="indicador indicador-sm"
                      [style.--indicador-cor]="integracao.cor"
                      [matTooltip]="integracao.rotulo"
                      [attr.aria-label]="integracao.rotulo"
                      >{{ integracao.sigla }}</span
                    >
                  }
                </span>
              } @else {
                —
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let row">
              <span class="status-cell">
                @if (row.isCancelada) {
                  <span class="status-badge status-badge-pai badge-vermelho">
                    <mat-icon class="material-symbols-outlined">cancel</mat-icon>
                    NF-e cancelada
                  </span>
                } @else {
                  <span class="status-badge status-badge-pai" [ngClass]="classeBadgeStatus(row)">
                    <mat-icon class="material-symbols-outlined">{{ iconeStatus(row) }}</mat-icon>
                    {{ status(row) }}
                  </span>
                  @if (subStatus(row)) {
                    <span class="status-badge status-badge-sub" [ngClass]="classeBadgeStatus(row)" [matTooltip]="tooltipSubStatus(row)">
                      {{ subStatus(row) }}
                    </span>
                  }
                  @for (etapa of etapasPedidos(row); track etapa.key) {
                    <span
                      class="status-badge status-badge--etapa-pedido"
                      [style.--etapa-cor]="etapa.cor"
                      [matTooltip]="etapa.tooltip"
                    >
                      <mat-icon class="material-symbols-outlined">{{ etapa.icone }}</mat-icon>
                      {{ etapa.nome }}
                    </span>
                  }
                }
                @if (row.possuiDivergencia) {
                  <span class="status-badge status-badge-pai badge-vermelho" matTooltip="Existe ao menos uma divergência pendente">
                    <mat-icon class="material-symbols-outlined">error</mat-icon>
                    Com divergência
                  </span>
                  @if (row.possuiDivergenciaBloqueante) {
                    <span class="status-badge status-badge-sub badge-vermelho">Divergência bloqueante</span>
                  }
                }
                @if (temPedidoComDivergencia(row)) {
                  <span class="status-badge badge-laranja" [matTooltip]="tooltipPedidoComDivergencia(row)">
                    <mat-icon class="material-symbols-outlined">report</mat-icon>
                    Pedido com divergência
                  </span>
                }
                @if (row.isReaberta) {
                  <span class="status-badge badge-amarelo">
                    <mat-icon class="material-symbols-outlined">restart_alt</mat-icon>
                    Reaberta
                  </span>
                }
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="acoes">
            <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
            <td mat-cell *matCellDef="let row" class="text-center w-actions">
              <button
                mat-icon-button
                type="button"
                class="icon-mat-symbols-btn btn-spinner"
                [class.btn-loading]="idNFeEntradaEmAcao === row.idNFeEntrada"
                [matMenuTriggerFor]="menu"
                [disabled]="idNFeEntradaEmAcao === row.idNFeEntrada"
                [attr.aria-label]="idNFeEntradaEmAcao === row.idNFeEntrada ? 'Executando ação da nota' : 'Ações da nota'"
                (menuOpened)="prepararAcoes(row)">
                <span class="material-symbols-outlined">more_horiz</span>
                @if (idNFeEntradaEmAcao === row.idNFeEntrada) { <mat-spinner diameter="20"></mat-spinner> }
              </button>
              <mat-menu #menu="matMenu" class="nfe-acoes-menu">
                @for (acao of acoesLinha; track acao.acao) {
                  <span [matTooltip]="acao.motivoIndisponivel" [matTooltipDisabled]="acao.isDisponivel">
                    <button
                      mat-menu-item
                      type="button"
                      [disabled]="!acao.isDisponivel"
                      (click)="executarAcao(acao, row)">
                      <mat-icon class="material-symbols-outlined">{{ acao.icone }}</mat-icon>
                      <span>{{ acao.rotulo }}</span>
                    </button>
                  </span>
                }
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>

      <div class="mobile-view">
        @for (row of dataSource.data; track row.idNFeEntrada) {
          <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(row)">
            <div class="card-header-mobile d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center gap-2">
                <mat-checkbox
                  (change)="selection.toggle(row)"
                  [checked]="selection.isSelected(row)"
                  color="primary"></mat-checkbox>
                <div class="d-flex flex-column">
                  <span class="text-bold">{{ nota(row) }}</span>
                  <small>{{ fornecedor(row) }}</small>
                  @if (row.cnpjCpfEmitente) {
                    <small class="fornecedor-documento">{{ row.cnpjCpfEmitente | cpfCnpj }}</small>
                  }
                </div>
              </div>
              <button
                mat-icon-button
                type="button"
                class="icon-mat-symbols-btn btn-spinner"
                [class.btn-loading]="idNFeEntradaEmAcao === row.idNFeEntrada"
                [matMenuTriggerFor]="menuMobile"
                [disabled]="idNFeEntradaEmAcao === row.idNFeEntrada"
                [attr.aria-label]="idNFeEntradaEmAcao === row.idNFeEntrada ? 'Executando ação da nota' : 'Ações da nota'"
                (menuOpened)="prepararAcoes(row)">
                <span class="material-symbols-outlined">more_horiz</span>
                @if (idNFeEntradaEmAcao === row.idNFeEntrada) { <mat-spinner diameter="20"></mat-spinner> }
              </button>
              <mat-menu #menuMobile="matMenu" class="nfe-acoes-menu">
                @for (acao of acoesLinha; track acao.acao) {
                  <span [matTooltip]="acao.motivoIndisponivel" [matTooltipDisabled]="acao.isDisponivel">
                    <button
                      mat-menu-item
                      type="button"
                      [disabled]="!acao.isDisponivel"
                      (click)="executarAcao(acao, row)">
                      <mat-icon class="material-symbols-outlined">{{ acao.icone }}</mat-icon>
                      <span>{{ acao.rotulo }}</span>
                    </button>
                  </span>
                }
              </mat-menu>
            </div>
            <div class="card-body-mobile p-3">
              <div class="row">
                <div class="col-6 mb-2">
                  <small class="d-block">Emissão</small>
                  <span>{{ row.dataEmissao | date: 'dd/MM/yyyy' }}</span>
                </div>
                <div class="col-6 mb-2">
                  <small class="d-block">Lançamento</small>
                  @if (isPreXml(row)) {
                    <span matTooltip="Disponível após o XML completo">—</span>
                  } @else {
                    <span>{{ row.dataEntradaSaida ? (row.dataEntradaSaida | date: 'dd/MM/yyyy') : '—' }}</span>
                  }
                </div>
                <div class="col-6 mb-2">
                  <small class="d-block">Destinatário</small>
                  <span class="truncate-cell">{{ destinatario(row) }}</span>
                </div>
                <div class="col-6 mb-2">
                  <small class="d-block">Valor (R$)</small>
                  <span class="text-bold">{{ row.valorTotal || 0 | abnt: 'preco' : 2 }}</span>
                </div>
                <div class="col-6 mb-2">
                  <small class="d-block">Origem</small>
                  <span class="status-badge badge-cinza">
                    <mat-icon class="material-symbols-outlined">{{ iconeOrigem(row) }}</mat-icon>
                    {{ origem(row) }}
                  </span>
                </div>
                <div class="col-6 mb-2">
                  <small class="d-block">Manifestação</small>
                  @if (temManifestacao(row)) {
                    <span class="status-badge" [ngClass]="classeBadgeManifestacao(row)">{{
                      manifestacao(row)
                    }}</span>
                  } @else {
                    <span>—</span>
                  }
                </div>
                <div class="col-6 mb-2">
                  <small class="d-block">Integrações</small>
                  @if (integracoes(row).length) {
                    <span class="indicador-grid">
                      @for (integracao of integracoes(row); track integracao.sigla) {
                        <span
                          class="indicador indicador-sm"
                          [style.--indicador-cor]="integracao.cor"
                          [matTooltip]="integracao.rotulo"
                          [attr.aria-label]="integracao.rotulo"
                          >{{ integracao.sigla }}</span
                        >
                      }
                    </span>
                  } @else {
                    <span>—</span>
                  }
                </div>
                <div class="col-12">
                  <small class="d-block">Status</small>
                  <span class="status-cell">
                    @if (row.isCancelada) {
                      <span class="status-badge status-badge-pai badge-vermelho">
                        <mat-icon class="material-symbols-outlined">cancel</mat-icon>
                        NF-e cancelada
                      </span>
                    } @else {
                      <span class="status-badge status-badge-pai" [ngClass]="classeBadgeStatus(row)">
                        <mat-icon class="material-symbols-outlined">{{ iconeStatus(row) }}</mat-icon>
                        {{ status(row) }}
                      </span>
                      @if (subStatus(row)) {
                        <span class="status-badge status-badge-sub" [ngClass]="classeBadgeStatus(row)" [matTooltip]="tooltipSubStatus(row)">
                          {{ subStatus(row) }}
                        </span>
                      }
                      @for (etapa of etapasPedidos(row); track etapa.key) {
                        <span
                          class="status-badge status-badge--etapa-pedido"
                          [style.--etapa-cor]="etapa.cor"
                          [matTooltip]="etapa.tooltip"
                        >
                          <mat-icon class="material-symbols-outlined">{{ etapa.icone }}</mat-icon>
                          {{ etapa.nome }}
                        </span>
                      }
                    }
                    @if (row.possuiDivergencia) {
                      <span class="status-badge status-badge-pai badge-vermelho" matTooltip="Existe ao menos uma divergência pendente">
                        <mat-icon class="material-symbols-outlined">error</mat-icon>
                        Com divergência
                      </span>
                      @if (row.possuiDivergenciaBloqueante) {
                        <span class="status-badge status-badge-sub badge-vermelho">Divergência bloqueante</span>
                      }
                    }
                    @if (temPedidoComDivergencia(row)) {
                      <span class="status-badge badge-laranja" [matTooltip]="tooltipPedidoComDivergencia(row)">
                        <mat-icon class="material-symbols-outlined">report</mat-icon>
                        Pedido com divergência
                      </span>
                    }
                    @if (row.isReaberta) {
                      <span class="status-badge badge-amarelo">
                        <mat-icon class="material-symbols-outlined">restart_alt</mat-icon>
                        Reaberta
                      </span>
                    }
                  </span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      <div
        class="text-center load-more"
        [matTooltip]="ultimaPagina ? 'Todas as notas foram carregadas' : ''">
        <button mat-button type="button" class="btn-spinner" [class.btn-loading]="isLoading" (click)="proximaPagina()"
          [disabled]="isLoading || ultimaPagina" [attr.aria-label]="isLoading ? 'Carregando mais notas' : 'Ver mais'">
          <span class="material-symbols-outlined">keyboard_arrow_down</span>
          Ver mais
          @if (isLoading) { <mat-spinner diameter="20"></mat-spinner> }
        </button>
      </div>
    } @else if (isLoading) {
      <app-loading-box-default-list></app-loading-box-default-list>
    } @else {
      <app-empty-list
        title="Nenhuma nota encontrada"
        subTitle="Tente alterar os filtros de busca"></app-empty-list>
    }
  </div>
</div>

<!-- Rodapé de totalização: padrão global .footer-totals. -->
<div class="footer-totals">
  <div class="footer-totals-inner">
    <div class="footer-totals-item footer-totals-item--total">
      <span class="footer-totals-label">Valor total (R$)</span>
      <span class="footer-totals-value">{{ resumo.valorTotal || 0 | abnt: 'preco' : 2 }}</span>
    </div>
    <div class="footer-totals-item footer-totals-item--alerta">
      <span class="footer-totals-label">Em lançamento (R$)</span>
      <span class="footer-totals-value">{{ resumo.valorEmLancamento || 0 | abnt: 'preco' : 2 }}</span>
    </div>
    <div class="footer-totals-item footer-totals-item--entrada">
      <span class="footer-totals-label">Lançadas no período (R$)</span>
      <span class="footer-totals-value">{{ resumo.valorLancadasMes || 0 | abnt: 'preco' : 2 }}</span>
    </div>
    <div class="footer-totals-count">
      <mat-icon class="material-symbols-outlined">description</mat-icon>
      <span>{{ dataSource.data.length }} de {{ fullListSize }} notas</span>
    </div>
  </div>
</div>
<div class="footer-totals-height-fake"></div>

<button
  class="btn-footer-totals-mobile"
  type="button"
  (click)="toggleGavetaMobile()"
  aria-label="Abrir resumo das notas">
  <span class="material-symbols-outlined">analytics</span>
</button>

@if (isMobileDrawerOpen) {
  <div class="footer-totals-mobile-sheet-backdrop" (click)="fecharGavetaMobile()"></div>
}
<div class="footer-totals-mobile-sheet" [class.open]="isMobileDrawerOpen">
  <div class="footer-totals-mobile-sheet__header modal-header">
    <div class="modal-header-icon">
      <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
    </div>
    <div class="modal-header-titles">
      <h3 class="modal-title">Resumo das notas</h3>
    </div>
    <div class="modal-header-close-btn-container">
      <button
        mat-icon-button
        type="button"
        class="modal-close-btn icon-mat-symbols-btn"
        (click)="fecharGavetaMobile()"
        aria-label="Fechar resumo das notas">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
  </div>
  <div class="footer-totals-mobile-sheet__content">
    <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--total">
      <span class="footer-totals-mobile-sheet__label">VALOR TOTAL (R$)</span>
      <span class="footer-totals-mobile-sheet__value">{{ resumo.valorTotal || 0 | abnt: 'preco' : 2 }}</span>
    </div>
    <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--alerta">
      <span class="footer-totals-mobile-sheet__label">EM LANÇAMENTO (R$)</span>
      <span class="footer-totals-mobile-sheet__value">{{
        resumo.valorEmLancamento || 0 | abnt: 'preco' : 2
      }}</span>
    </div>
    <div
      class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--entrada footer-totals-mobile-sheet__item--full">
      <span class="footer-totals-mobile-sheet__label">LANÇADAS NO MÊS (R$)</span>
      <span class="footer-totals-mobile-sheet__value">{{
        resumo.valorLancadasMes || 0 | abnt: 'preco' : 2
      }}</span>
    </div>
  </div>
  <div class="footer-totals-mobile-sheet__footer">
    <span class="footer-totals-count">
      <mat-icon class="material-symbols-outlined">description</mat-icon>
      {{ dataSource.data.length }} de {{ fullListSize }} notas
    </span>
  </div>
</div>
